import z from "zod";

export const articleProductTypeFormSchema = z.object({
	id: z.string().nullish(),
	name: z.string(),
	number: z.coerce.number().min(0).max(999),
	articleGroupId: z.uuid(),
	autoGenerateNumber: z.preprocess((val) => {
		if (!val) return false;
		return true;
	}, z.boolean()),
	description: z.string().nullish(),
});

export type ArticleProductTypeFormSchema = z.infer<typeof articleProductTypeFormSchema>;
